export default function customShadows() {
  return {
    basic: "0px 3px 18px 2px rgb(0 0 0 / 9%)",
    glass: "inset 0 0 2000px rgba(255, 255, 255, .5)",
    filter: "blur(10px)",
  };
}
